import differenceInSeconds from 'date-fns/difference_in_seconds'
import timer from './timer'

export default {
  mixins: [timer],
  props: {
    date: {
      type: Date,
      default: new Date()
    }
  },
  data() {
    return {
      remaining: 0
    }
  },
  methods: {
    tick() {
      const seconds = Math.max(differenceInSeconds(this.date, new Date()), 0)
      if (seconds === 0) {
        this.stop()
      }

      this.remaining = seconds
    }
  }
}
